import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { MessageCircle, Trash2, Copy } from 'lucide-react';
import type { FlowNodeProps } from '@/types/flow';

const ReplyNode = ({ data, selected }: FlowNodeProps) => {
    const message = data.config?.message || 'Sem mensagem configurada';
    const preview = message.length > 80 ? message.substring(0, 80) + '...' : message;

    return (
        <div
            className={`
                bg-white rounded-lg shadow-sm min-w-[220px] max-w-[300px]
                transition-all duration-150 group
                ${selected ? 'shadow-md ring-2 ring-green-400/40' : 'hover:shadow-md'}
            `}
            style={{ borderLeft: '3px solid #22c55e', border: selected ? undefined : '1px solid #e5e7eb', borderLeftWidth: '3px', borderLeftColor: '#22c55e' }}
        >
            <div className="px-3 py-2.5">
                <div className="flex items-center gap-2 mb-1.5">
                    <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 bg-green-100">
                        <MessageCircle className="w-3.5 h-3.5 text-green-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <span className="text-[10px] text-gray-400 uppercase tracking-wider font-medium block">Resposta Pública</span>
                        <span className="font-semibold text-[13px] text-gray-800 block truncate">
                            {data.node_name || 'Resposta'}
                        </span>
                    </div>
                    <button
                        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-blue-50 text-gray-400 hover:text-blue-500"
                        title="Duplicar"
                        onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
                    >
                        <Copy className="w-3 h-3" />
                    </button>
                    <button
                        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-500"
                        onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
                    >
                        <Trash2 className="w-3 h-3" />
                    </button>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed">{preview}</p>
            </div>

            <Handle type="target" position={Position.Left} id="target" className="!w-3.5 !h-3.5 !bg-[#2196F3] !border-2 !border-white" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
            <Handle type="source" position={Position.Right} id="source" className="!w-3.5 !h-3.5 !bg-[#2196F3] !border-2 !border-white" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
        </div>
    );
};

export default memo(ReplyNode);
